module.exports = __webpack_public_path__ + "img/logo2.48c548e2.png";